<template>

    <div id="products">

        <div class="flex flex-row justify-between pb-4">
            <div class="flex">
                <h1 class="text-2xl font-medium text-gray-900 capitalize">Products</h1>

                <ProductsFilter @submitFilter="this.submitFilter" @resetFilters="this.resetFilters"></ProductsFilter>
            </div>
            <div class="justify-self-end">
                <router-link :to="{ name: 'products.sync' }" custom v-slot="{ navigate }" v-if="$parent.isAdmin">
                    <button @click="navigate" class="btn justify-center px-6 ml-6">
                        Product Sync
                    </button>
                </router-link>
            </div>
        </div>

        <div class="flex h-auto" v-if="loaded">
            <div class="flex-1" v-if="form.productsAvailable()">
                <ul class="grid gap-6" :class="{ 'grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4': !form.selected, 'grid-cols-1 lg:grid-cols-1 xl:grid-cols-1 2xl:grid-cols-2 px-20 lg:px-0': form.selected }"> <!---->
                    <li class="col-span-1 bg-gray-50 rounded-lg shadow divide-y divide-gray-200 rounded-2xl" v-for="(product, index) in form.products.data">
                        <a href="#" @click.prevent="toggleViewProduct(index)">
                            <div class="w-full flex items-center justify-between space-x-6 rounded-t-2xl bg-gray-200 p-2">
                                <img class="object-contain h-48 rounded-2xl mx-auto" :src="product.meta.image" :alt="product.name">
                            </div>
                            <div class="flex px-5 py-3">
                                <div class="flex-1">
                                    <h3 class="flex sub-heading font-medium text-sm text-gray-700 mb-4">
                                        {{ ellipsis(product.name, 32) }}
                                    </h3>
                                    <p class="text-gray-400 text-xs">
                                        {{ ellipsis(product.sku, 24) }}
                                    </p>
                                    <p class="text-red-400 text-xs" v-if="$parent.isAdmin">
                                        {{ product.processor_id }}
                                    </p>
                                </div>
                                <div class="flex text-2xl items-center ">
                                    <p class="font-medium text-brand-600 text-center">
                                        {{ (product.discount / 100) }}<span class="text-sm">%</span>
                                    </p>
                                </div>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="panel flex-1" v-else>
                <div class="p-10">
                    <div class="text-gray-200 my-6">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-20 w-20 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                        </svg>
                    </div>

                    <h2 class="text-gray-600 font-medium text-2xl text-center">No Products Available</h2>

                    <p class="text-center mt-4 text-sm text-gray-500">
                        We could not find any products.
                    </p>
                </div>
            </div>
            <div class="hidden lg:block lg:w-1/2" v-if="form.selected">
                <div class="sticky top-10 ml-6 panel border-t-4 border-brand-500 rounded-t-none max-h-120 xl:max-h-132 overflow-y-scroll">



                    <div class="flex items-center font-medium text-2xl">
                        <h1 class="flex-1 items-center">
                            {{ form.selected.name }}
                        </h1>

                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 cursor-pointer" fill="none" viewBox="0 0 24 24" stroke="currentColor" @click.prevent="closeViewProduct()">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </div>
                    <h2 class="flex items-center font-medium text-sm text-gray-400 mb-5">{{ form.selected.sku }}</h2>

                    <div class="flex">
                        <table class="text-sm mb-5 w-full xl:w-2/3">
                            <tbody>
                            <tr>
                                <td class="w-2/6 text-gray-400 py-1">Brand</td>
                                <td class="w-4/6">{{ form.selected.brand }}</td>
                            </tr>
                            <tr>
                                <td class="w-2/6 text-gray-400 py-1">SKU</td>
                                <td class="w-4/6 font-medium">{{ form.selected.sku }}</td>
                            </tr>
                            <tr>
                                <td class="w-2/6 text-gray-400 py-1">Type</td>
                                <td class="w-4/6">
                                    <span class="mr-1 status-box status-open">{{ form.selected.type }}</span>
                                    <span class="mr-1 status-box status-action-required" v-if="form.selected.delay">delay</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="w-2/6 text-gray-400 py-1">Currency</td>
                                <td class="w-4/6">{{ form.selected.currency }}</td>
                            </tr>
                            <tr>
                                <td class="w-2/6 text-gray-400 py-1">Redemption</td>
                                <td class="w-4/6">
                                    <span class="mr-1 status-box status-complete" v-if="form.selected.meta.online">Online</span>
                                    <span class="mr-1 status-box status-complete" v-if="form.selected.meta.in_store">In Store</span>
                                    <span class="mr-1 status-box status-complete" v-if="form.selected.meta.telephone">Telephone</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="w-2/6 text-gray-400 py-1">Reload</td>
                                <td class="w-4/6">
                                    <template v-if="form.selected.serial || form.selected.pan">
                                        <span class="mr-1 status-box status-complete" v-if="form.selected.serial">Serial</span>
                                        <span class="mr-1 status-box status-complete" v-if="form.selected.pan">PAN</span>
                                    </template>
                                    <span class="mr-1 status-box status-pending" v-else>Not Reloadable</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="flex-1 pb-4 hidden xl:flex">
                            <img :src="form.selected.meta.image" :alt="form.selected.name" class="object-contain">
                        </div>
                    </div>


                    <hr class="mb-4 border-gray-300">

                    <table class="text-sm mb-3 w-full">
                        <tbody >
                            <tr>
                                <td class="w-2/6 text-gray-400 py-1">Discount</td>
                                <td class="w-4/6">{{ form.selected.discount / 100 }}%</td>
                            </tr>
                            <tr>
                                <td class="w-2/6 text-gray-400 py-1">Tax</td>
                                <td class="w-4/6">{{ form.selected.tax / 100 }}%</td>
                            </tr>
                            <tr v-if="form.selected.max_value > 0">
                                <td class="w-2/6 text-gray-400 py-1">Minimum Load</td>
                                <td class="w-4/6">
                                    {{ formatCurrency(form.selected.currency, form.selected.min_value / 100) }}
                                </td>
                            </tr>
                            <tr v-if="form.selected.max_value">
                                <td class="w-2/6 text-gray-400 py-1">Maximum Load</td>
                                <td class="w-4/6">
                                    {{ formatCurrency(form.selected.currency, form.selected.max_value / 100) }}
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="container mx-auto mb-3" v-if="form.selected.denominations">
                        <div class="w-2/6 text-gray-400 py-1">Denominations</div>
                        <div class="grid grid-cols-6 md:grid-cols-6 lg:grid-cols-6 gap-1">
                            <div class="flex justify-center status-box mr-1 status-box status-pending" v-for="denom in getSelectedProductDenominations()">{{ denom }}</div>
                        </div>
                    </div>

                    <hr class="mb-4 border-gray-300">

                    <h3 class="font-medium mb-1 text-base">Product Description</h3>

                    <p class="flex text-sm mb-2 text-gray-500">
                        {{ form.selected.meta.description ? form.selected.meta.description : '-' }}
                    </p>

                    <hr class="mb-4 border-gray-300">

                    <h3 class="font-medium mb-1 text-base">Redemption Instructions</h3>

                    <p class="flex text-sm mb-2 text-gray-500">
                        {{ form.selected.meta.redemption_instructions_copy ? form.selected.meta.redemption_instructions_copy : '-' }}
                    </p>

                    <p class="flex text-sm mb-2" v-if="form.selected.meta.redemption_instructions_url">
                        <a :href="form.selected.meta.redemption_instructions_url" target="_blank">
                            {{ form.selected.meta.redemption_instructions_url }}
                        </a>
                    </p>

                    <hr class="mb-4 border-gray-300">

                    <h3 class="font-medium mb-1 text-base">Terms</h3>

                    <p class="flex text-sm mb-2 text-gray-500">
                        {{ form.selected.meta.terms_and_conditions_copy ? form.selected.meta.terms_and_conditions_copy : '-' }}
                    </p>

                    <p class="flex text-sm mb-2" v-if="form.selected.meta.terms_and_conditions_url">
                        <a :href="form.selected.meta.terms_and_conditions_url" target="_blank">
                            {{ form.selected.meta.terms_and_conditions_url }}
                        </a>
                    </p>
                </div>
            </div>
        </div>
        <Loading message="Loading Products" v-else></Loading>

    </div>

</template>

<script>
import Loading from "../Support/Loading";
import {Product} from "../../app/Product/Product";
import ProductsFilter from "./ProductsFilter";
import {FormattingMixin, PermissionMixin} from "../../support/mixins";

export default {
    name: "Products",
    mixins: [PermissionMixin, FormattingMixin],
    props: {
        timeout_length: {
            type: Number,
            required: false,
            default: 600
        }
    },
    data() {
        return {
            form: null,
            loaded: false,
        }
    },
    components: {
        Loading,
        ProductsFilter
    },
    methods: {
        submitFilterDelayed() {
            let vm = this;

            clearTimeout(vm.timeout);

            vm.timeout = setTimeout(function() {
                vm.submitFilter();
            }, this.timeout_length);
        },
        submitFilter(query) {
            let vm = this;

            if(query === '') {
                return this.loadAll();
            }

            new Promise(resolve => {
                this.form.search(query).then(response => {
                    resolve(true);
                }).catch(error => vm.handleError(error));

            }).then(result => {
                vm.loaded = result;
            });
        },
        resetFilters() {
            this.loadAll();
        },
        getSelectedProductDenominations() {
            let vm = this;
            let selected = vm.form.selected;
            let data = [];

            if (selected.denominations) {
                for (const key in selected.denominations) {
                    data[key] = vm.formatCurrency(selected.currency, selected.denominations[key] / 100);
                }
            }

            return data;
        },
        toggleViewProduct(index) {
            let product = this.form.products.data[index];

            if (this.form.selected.sku === product.sku) {
                this.form.selected = false;
            } else {
                this.form.selected = product;
            }
        },
        closeViewProduct() {
            this.form.selected = false;
        },
        loadAll() {
            let vm = this;

            new Promise(resolve => {
                vm.form = new Product();

                vm.form.all().then(response => {
                    resolve(true);
                }).catch(error => vm.handleError(error));

            }).then(result => {
                vm.loaded = result;
            });
        }
    },
    mounted() {
        this.loadAll();
    }
}
</script>


